import { UserAction, UserActionTypes, UserState } from '../types/userTypes';
import { getJWT, parseJWT } from '../utils/auth';

let token = getJWT();

export const initialState: UserState = {
  isLogged: token ? true : false,
  isSessionExpired: false,
  userData: token ? parseJWT(token) : undefined,
  hasCheckedToken: false,
};

const userReducer = (state: UserState, action: UserAction): UserState => {
  switch (action.type) {
    case UserActionTypes.RESET_STATE:
      return {
        ...initialState,
        isLogged: false,
        hasCheckedToken: true,
      };

    case UserActionTypes.SET_IS_LOGGED:
      return {
        ...state,
        isLogged: action.payload,
      };

    case UserActionTypes.SET_IS_SESSION_EXPIRED:
      return {
        ...state,
        isSessionExpired: action.payload,
      };

    case UserActionTypes.SET_FULL_NAME: {
      const userData = state.userData && {
        ...state.userData,
        fullName: action.payload,
      };

      return {
        ...state,
        userData,
      };
    }

    case UserActionTypes.SET_USER_DATA: {
      const prevUserData = state.userData;
      const userData = prevUserData
        ? { ...prevUserData, ...action.payload }
        : (action.payload as UserState['userData']);

      return {
        ...state,
        userData,
      };
    }

    default:
      return state;
  }
};

export default userReducer;
